import type { IconSvgObject } from './types';

const Svg01Icon: IconSvgObject = [
  ["path", { d: "M3.99988 12.9978L4.01982 3.99557C4.02226 2.89186 4.91833 1.99877 6.02204 2L12.9957 2.00776L19.9999 8.99481L19.9921 12.9978M12.9999 2.49778V6.99778C12.9999 8.10235 13.8953 8.99778 14.9999 8.99778H19.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.00008 16H3.99988V19H7.00008V22H3.99988", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.9999 17V16H16.4999V22H19.9999V19.5H18.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14.0001 16L11.75 22L9.49988 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Svg01Icon;
